import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
  TrainerExerciseDetailsResponseMastery,
  TrainerService,
} from '@thiememeulenhoff/thor-client';
import { firstValueFrom } from 'rxjs';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type MasteryState = {
  mastery: TrainerExerciseDetailsResponseMastery;
  badgeCount: number;
};

const initialState: MasteryState = {
  mastery: {},
  badgeCount: 0,
};

export const MasteryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(),
  withMethods((store, trainerService = inject(TrainerService)) => ({
    async fetchMasteryProgress(
      arrangementCode: string,
      wordListId: string,
    ): Promise<void> {
      patchState(store, {
        mastery: initialState.mastery,
        badgeCount: 0,
        requestStatus: 'loading',
      });
      try {
        const exercise = await firstValueFrom(
          trainerService.getTrainerExercise('wordlist', wordListId, {
            arrangementCode,
          }),
        );
        patchState(store, {
          mastery: exercise.mastery ?? initialState.mastery,
          badgeCount: exercise.achievements.length,
          requestStatus: 'success',
        });
      } catch (error) {
        patchState(store, { requestStatus: toRequestError(error) });
        throw error;
      }
    },
  })),
);
